import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysShipActionButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.materialOutput")}</ActionButtonLayout>;

}

export default MomSysShipActionButtonLayout;

